<template>
  <component
    :is="tag"
    :class="{ 'bg-light-primary': $store.state.chat.activeRoom && $store.state.chat.activeRoom.id === room.id }"
    v-on="$listeners"
  >
    <b-avatar
      size="42"
      :src="linkStaging(room.user_1.photo_url, 42, 42)"
      :text="avatarText(room.user_1.name)"
      variant="primary"
    />
    <div class="chat-info flex-grow-1">
      <h5
        class="mb-0"
        :class="{ 'text-primary font-weight-bolder': $store.state.chat.activeRoom && $store.state.chat.activeRoom.id === room.id }"
      >
        {{ room.user_1.name }}
      </h5>
      <p
        v-if="isTyping"
        class="card-text text-truncate mt-25"
      ><i>Mengetik...</i></p>
      <p
        v-else
        class="card-text text-truncate mt-25 d-flex align-items-center"
      >
        <img
          v-if="$store.state.appConfig.layout.skin === 'dark' && room.last_chat.id && room.last_chat.sender_id !== room.user_1.id"
          width="16"
          height="16"
          class="border-0 mr-25 mb-25 opacity-50"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAkklEQVR4nO2RwQmEMBBF04TBHG1ie9L+bMQI9rENPAlRkDCYMa542PzjY3jDzDempubVABbotbxE7okZcvyqvAGmTbIA7Rn/X7lTy0PjoZwzDnyALzAf2LFQLznC0CANSJy4RC+/eLrLdfGL/7riQreTZ+EtNnlF/i3KJWPCd3GZPJGNQCdwf0uuXG4fkdeYp7ICMxv09RY42L8AAAAASUVORK5CYII="
        >
        <img
          v-else-if="$store.state.appConfig.layout.skin === 'dark' && room.last_chat.sender_id !== room.user_1.id"
          width="16"
          height="16"
          class="border-0 mr-25 mb-25 opacity-50"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAbElEQVR4nO2SQQ6AIAwE+YREnwjPtQeeM8boiVSCWoyHzplO02VDcJw7ABFII+XCQbaWT8B6ygswuzz8NxYg7Y3obIu03mrDuTXIG/nF6Yt55toSrD9UiUIex9J5iX0VqyXFXF7FFYfInU/YACecNBrPmY0rAAAAAElFTkSuQmCC"
        >
        <img
          v-else-if="room.last_chat.id && room.last_chat.sender_id !== room.user_1.id"
          width="16"
          height="16"
          class="border-0 mr-25 mb-25 opacity-50"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAi0lEQVR4nO2RwQ2AIBAEpwmJPG3CnrA/GwET+7ABjcYHMaAcBv2wzwmZ5e6gpubvKMAIuFjugBUYErgoDWBPyQy0D1z8c1tS7r6Sa4ncnII73gMLMHnML3URx3Hp0IMQ76Xy0Ij6gWftXFLS5B40NrK68KS1pJSMEZ4t92W7vIuUv5KnlKtS8hqKZAOmMUyTiuIjcQAAAABJRU5ErkJggg=="
        >
        <img
          v-else-if="room.last_chat.sender_id !== room.user_1.id"
          width="16"
          height="16"
          class="border-0 mr-25 mb-25 opacity-50"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAa0lEQVR4nO2SQQ6AIAwE5xMQfSI81x54Dl4wIYpBAzUeOmeYwnbBMF7igaApFyADcbbcAVuRJ2Ax+b9jCaURT9oinbMXYueiH5G3vr5qZN4a4mYv9ByFjMRyR/3qrFHFekjSkB/4mbEY37MDq8wwEEHSl/sAAAAASUVORK5CYII="
        >
        {{ room.last_chat.message }}
      </p>
    </div>
    <div
      v-if="isChatContact"
      class="chat-meta text-nowrap"
    >
      <small class="float-right mb-25 chat-time">{{ formatDateToMonthShort(room.last_chat.created_at, { hour: 'numeric', minute: 'numeric' }) }}</small>
      <b-badge
        v-if="false"
        pill
        variant="primary"
        class="float-right mr-25"
      >
        2
      </b-badge>
    </div>
  </component>
</template>

<script>
import { BAvatar, BBadge, BImg } from 'bootstrap-vue'
import { formatDateToMonthShort, avatarText } from '@core/utils/filter'
import store from '@/store'
import useChat from './useChat'

export default {
  components: {
    BImg,
    BAvatar,
    BBadge,
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    room: {
      type: Object,
      required: true,
    },
    isChatContact: {
      type: Boolean,
      default: false,
    },
    isTyping: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      avatarText,
    }
  },
  computed: {
    store() {
      return store
    },
  },
  setup() {
    const { resolveAvatarBadgeVariant } = useChat()
    return { formatDateToMonthShort, resolveAvatarBadgeVariant }
  },
}
</script>

<style>

</style>
